import React, {useState, useContext, useEffect} from "react";
import styles from "./bpmnModelsList/BpmnModelsList.module.scss";
import BpmnModelItem from "./bpmnModelsList/BpmnModelItem";
import AddNewBpmnItem from "./bpmnModelsList/AddNewBpmnItem";
import TopMenu from "./bpmnModelsList/TopMenu";
import ImportBpmnModal from "./conformanceChecking/ImportBpmnModal";
import ConformanceCheckingLandingPage from "./AddNewBpmnLangingPage";
import appContext from "../../../context/appContext";
import {useFetch} from "../../../hooks/useFetch.hook";

const BpmnModelsList = ({ showContent }) => {
  const context = useContext(appContext);
  const [showModal, setShowModal] = useState(false);
  const handleTriggerShowModal = () => {
    !showModal ? setShowModal(true) : setShowModal(false);
  }

  let analysisId = null;
  if (context.handleUid().id) {
    analysisId = context.handleUid().id;
  } else {
    analysisId = JSON.parse(localStorage.getItem("mapData")).id;
  }

  const {data, status, refetch} = useFetch(`process_mining/bpmn/${analysisId}`)

  let showData = null;
  if (data?.length) {
    showData = data.map(item => (
        <BpmnModelItem
            id={item.id}
            title={item.name}
            created={item.created}
            description={item.description}
            file={item.file}
            redirectTo={showContent}
            refetch={refetch}
        />
    ));
  }

  useEffect(() => {
    refetch()
  }, [])

  const Template = () => {
    if (data && !status.isLoading) {
      if (data.length === 0) {
        return <ConformanceCheckingLandingPage
            handleTriggerShowModal={handleTriggerShowModal}
        />
      } else {
        return (
            <div className={[styles.BpmnModelsList, 'container-fluid'].join(' ')}>
              <div className={'row'}>
                <TopMenu
                    handleTriggerShowModal={handleTriggerShowModal}
                    numberOfResults={data.length}
                />
              </div>
              <div className={'row mt-4'}>
                { showData }
                <AddNewBpmnItem
                    handleTriggerShowModal={handleTriggerShowModal}
                />
              </div>
            </div>
        )
      }
    } else if (status.isError) {
      return <div>Error...</div>
    } else {
      return <div>Please Wait...</div>
    }
  }

  return (
      <>
        <Template />
        <ImportBpmnModal
            handleSetRefresh={refetch}
            showModal={showModal}
            handleTriggerShowModal={() => handleTriggerShowModal()}
        />
      </>
  )
};

export default BpmnModelsList;
